import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react'

const CustomCheckbox = ({location, label, value, index, handleLocationsInputChange}: any) => {
    if(value == 'Online Payment') {
        value = 'Online'
    }
  return (
    <FormControlLabel style={{color:"#3E3E3E",fontSize:"14px"}} control={
        <Checkbox 
          style={{color:"#787878",fontSize:"14px"}}
          checked={location.paymentMethod?.includes(value) || false}
          onChange={(e)=>{
                   const {checked } = e.target;
                   let paymentMethod=[]
                   if (checked) {
                   paymentMethod=location.paymentMethod?[...location.paymentMethod,value]:[value]
                   } else {
                   paymentMethod= location.paymentMethod?.filter((val:any) => val !== value);
                   }
               handleLocationsInputChange(index,paymentMethod,"paymentMethod")
           }} />} 
        label={label} />
  )
}

export default CustomCheckbox